import { hashValue } from '../../utils/hashValue.ts';

const HTML_TAGS_REGEX = /<\/?(p|strong|div|a|span|b|u|h1|h2|h3|h4|h5|ul|li)>/g;

/**
 * Rimuove da una stringa tutti i caratteri superflui e la ritorna
 * pronta per essere usata in una key per le chiavi di traduzione
 */
export function clearString(value: string) {
  const normalizedValue = value
    // Tronco a 50 caratteri
    .slice(0, 50)
    // Rimuovo i tag html
    .replace(HTML_TAGS_REGEX, '')
    // Rimuovo i caratteri di spazio multipli
    .replace(/\s{2,}/g, ' ')
    .trim()

    // Rimuovo i caratteri speciali
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .trim()
    // Sostituisco gli spazi con "-"
    .replace(/( )+/g, '-');

  return normalizedValue;
}

/**
 * Ritorna una versione normalizzata del valore di un campo
 * che ne permette il riconoscimento anche in caso di modifiche
 */
export function getNormalizedValue(value: string) {
  const normalizedValue = clearString(value);

  // Calcolo l'hash del valore
  const hashed = hashValue(value);

  // Ritorno il valore normalizzato e l'hash che costituisce il "valoreEtichettaNormalizzato"
  return `${normalizedValue}${hashed > 0 ? '-' : ''}${hashed}`;
}
